var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAccountPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 13.7368C13.0781 11.1208 15.2817 9 18 9C20.7183 9 22.9219 11.1208 22.9219 13.7368C22.9219 16.3529 20.7183 18.4737 18 18.4737C15.2817 18.4737 13.0781 16.3529 13.0781 13.7368ZM18 16.5789C19.631 16.5789 20.9531 15.3065 20.9531 13.7368C20.9531 12.1672 19.631 10.8947 18 10.8947C16.369 10.8947 15.0469 12.1672 15.0469 13.7368C15.0469 15.3065 16.369 16.5789 18 16.5789Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4315 21.6409C10.9547 23.0622 10.125 24.9899 10.125 27H12.0938C12.0938 25.4925 12.716 24.0467 13.8237 22.9807C14.9313 21.9147 16.4336 21.3158 18 21.3158C19.5664 21.3158 21.0687 21.9147 22.1764 22.9807C23.284 24.0467 23.9062 25.4925 23.9062 27H25.875C25.875 24.9899 25.0453 23.0622 23.5685 21.6409C22.0916 20.2195 20.0886 19.4211 18 19.4211C15.9114 19.4211 13.9084 20.2195 12.4315 21.6409Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountPlaceholder);
export default __webpack_public_path__ + "static/media/account-placeholder.81f7686a.svg";
export { ForwardRef as ReactComponent };